<div class="generic-confirm-modal">
  <div class="generic-confirm-modal__body">
    <p data-testid="awaiting-signer-acknowledgement-message" class="generic-confirm-modal__p">
      Please ask the signer to acknowledge document signing.
    </p>
    <!-- TEMP: dev-only until cross-device ack propagation lands -->
    <button
      type="button"
      data-testid="dev-mark-acknowledged"
      (click)="devMarkAcknowledged.emit()"
    >
    Signer acknowledged
    </button>
  </div>
</div>
